import styled from "styled-components";
import { deviceSpec } from "breakpoints";
import { Autocomplete, TableCell, TableContainer, TableRow } from "@mui/material";

export const TableContainerStyled = styled(TableContainer)`
  input[type="checkbox"] {
    opacity: 0;
  }
  th {
    font-size: 12px;
    font-weight: 700;
    line-height: 12px;
    letter-spacing: 0em;
    text-align: left;
    border-bottom: 2px solid grey;
  }
  tr {
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 12px;
    &.selected-row, &.selected-row:hover {
      background: ${({ theme }) => theme.colors.dark};
    }
  }
  svg[data-testid="ArrowDownwardIcon"] {
    position: absolute;
    right: -24px;
  }
  svg[data-testid="filterIcon"] {
    margin-left: 20px;
  }
  tbody td {
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0em;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 150px;
  }
  tr {
    height: max-content;
    padding: 0 1em;
  }
  .dot {
    height: 13px;
    width: 13px;
    background-color: #64ff50;
    border-radius: 50%;
    display: inline-block;
  }
  .MuiInputBase-input {
    font-size: 14px;
  }
  .MuiAutocomplete-popper {
    width: max-content !important;
    .MuiAutocomplete-option, .Mui-focused, div {
      border: 1px blue;
      font-size: 12px;
      margin: 0px;
      text-overflow: ellipsis;

      ul, span {
        align-self: center;
        text-overflow: ellipsis;
      } 
    }
  }

  th, td {
    width: auto;
    white-space: nowrap;
  }
`;

export const AutocompleteDropDown = styled(Autocomplete)`
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`

export const SpanActiveStatusStyled = styled.span`
  text-overflow: ellipsis;
`;
export const SpanDeactiveStatusStyled = styled.span`
  color: grey;
  text-overflow: ellipsis;
`;
export const SpanEmailStyled = styled.span`
  color: ${({ theme }) => theme.colors.highlight3};
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: translate(0, 25%);
`;

export const SpanIdStyled = styled.span`
  color: #${({ theme }) => theme.colors.highlight3};
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  transform: translate(0, 25%);
  width: 100%;
`;

export const PaginationWrapperStyled = styled.div`
  .MuiToolbar-root {
    display: flex;
    justify-content: center;

    @media ${deviceSpec.isMobile} {
      flex-direction: column;
      padding-top: 2em;

      [class$="-MuiTablePagination-select"] {
        margin: 0;
      }

      .MuiTablePagination-actions {
        margin: 0;
      }
    }
  }

  .MuiTablePagination-spacer { 
    display: none;
  }
`

export const SelectField = styled.select`
  // color: white;
  background-color: transparent;
  border: none;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: left;
  height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const MoreRow = styled(TableRow)`
  span {
    color: ${({theme}) => theme.colors.textColor} !important;
  }

  td {
    display: flex;
    align-items: center;
    word-wrap: anywhere;
  }
  td:nth-child(even) {
    flex-grow: 3 !important;
    max-width: 80%;
    word-wrap: anywhere;
  }
  td:nth-child(odd) {
    flex-grow: 1 !important;
    max-width: 20%;
  }
`

export const MoreCell = styled(TableCell)`
  border-bottom: none !important;
`

export const CriticatilityCellDiv = styled('div')`
  display: flex;
  align-items: center;
  
  svg {
    margin-right: 0.75rem;
  }
`